import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

interface ExecuteRecaptchaProps {
  callback: (...args: any[]) => any;
  params: any[];
  action?: string; // Custom action name for reCAPTCHA (default: 'fetchData')
}

export const useExecuteRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();

  const execute = useCallback(
    async ({ callback, params, action = 'fetchData' }: ExecuteRecaptchaProps) => {
      if (!executeRecaptcha) {
        console.error('reCAPTCHA not loaded yet');
        return;
      }
      try {
        const token = await executeRecaptcha(action);
        dispatch(callback(...params, token));
      } catch (error) {
        console.error('Error executing reCAPTCHA:', error);
      }
    },
    [executeRecaptcha, dispatch]
  );

  return { execute };
};
